import $ from "cash-dom";

export default (function () {
    if (typeof jdmn_matomo == "undefined") return;

    var settings = {
        showIntro: false,
        divId: "matomo-opt-out",
        useSecureCookies: true,
        cookiePath: null,
        cookieDomain: null,
        // cookieDomain: ".berlintxl.de",
        cookieSameSite: "Lax",
        OptOutComplete: jdmn_matomo.OptOutComplete,
        OptOutCompleteBis: jdmn_matomo.OptOutCompleteBis,
        YouMayOptOut2: jdmn_matomo.YouMayOptOut2,
        YouMayOptOut3: jdmn_matomo.YouMayOptOut3,
        OptOutErrorNoCookies: jdmn_matomo.OptOutErrorNoCookies,
        OptOutErrorNotHttps: jdmn_matomo.OptOutErrorNotHttps,
        YouAreNotOptedOut: jdmn_matomo.YouAreNotOptedOut,
        UncheckToOptOut: jdmn_matomo.UncheckToOptOut,
        YouAreOptedOut: jdmn_matomo.YouAreOptedOut,
        CheckToOptIn: jdmn_matomo.CheckToOptIn,
    };

    document.addEventListener("DOMContentLoaded", function () {
        window.MatomoConsent.init(
            settings.useSecureCookies,
            settings.cookiePath,
            settings.cookieDomain,
            settings.cookieSameSite,
        );
        showContent(window.MatomoConsent.hasConsent());
    });

    function showContent(consent, errorMessage = null, useTracker = false) {
        var errorBlock = '<p style="color: red; font-weight: bold;">';

        var div = document.getElementById(settings.divId);
        if (!div) {
            var msg = 'Unable to find opt-out content div: "' + settings.divId + '"';
            // var warningDiv = document.createElement("div");
            // warningDiv.id = settings.divId + "-warning";
            // warningDiv.innerHTML = errorBlock + msg + "</p>";
            // document.body.insertBefore(warningDiv, document.body.firstChild);
            console.log(msg);
            return;
        }

        if (!navigator || !navigator.cookieEnabled) {
            div.innerHTML = errorBlock + settings.OptOutErrorNoCookies + "</p>";
            return;
        }

        if (errorMessage !== null) {
            div.innerHTML = errorBlock + errorMessage + "</p>";
            return;
        }

        var content = "";

        if (location.protocol !== "https:") {
            content += errorBlock + settings.OptOutErrorNotHttps + "</p>";
        }

        if (consent) {
            if (settings.showIntro) {
                content += "<p>" + settings.YouMayOptOut2 + " " + settings.YouMayOptOut3 + "</p>";
            }
            if (useTracker) {
                content +=
                    '<input onclick="_paq.push([\'optUserOut\']);showContent(false, null, true);" id="trackVisits" type="checkbox" checked="checked" style="height: 1lh; font-size: inherit"/>';
            } else {
                content +=
                    '<input onclick="window.MatomoConsent.consentRevoked();showContent(false);" id="trackVisits" type="checkbox" checked="checked" style="height: 1lh; font-size: inherit"/>';
            }
            content +=
                '<label for="trackVisits"><span>' +
                settings.YouAreNotOptedOut +
                " " +
                settings.UncheckToOptOut +
                "</span></label>";
        } else {
            if (settings.showIntro) {
                content += "<p>" + settings.OptOutComplete + " " + settings.OptOutCompleteBis + "</p>";
            }
            if (useTracker) {
                content +=
                    '<input onclick="_paq.push([\'forgetUserOptOut\']);showContent(true, null, true);" id="trackVisits" type="checkbox" style="height: 1lh; font-size: inherit"/>';
            } else {
                content +=
                    '<input onclick="window.MatomoConsent.consentGiven();showContent(true);" id="trackVisits" type="checkbox" style="height: 1lh; font-size: inherit"/>';
            }
            content +=
                '<label for="trackVisits"><span>' +
                settings.YouAreOptedOut +
                " " +
                settings.CheckToOptIn +
                "</span></label>";
        }
        div.innerHTML = content;
    }

    window.MatomoConsent = {
        cookiesDisabled: !navigator || !navigator.cookieEnabled,
        CONSENT_COOKIE_NAME: "mtm_consent",
        CONSENT_REMOVED_COOKIE_NAME: "mtm_consent_removed",
        cookieIsSecure: false,
        useSecureCookies: true,
        cookiePath: "",
        cookieDomain: "",
        cookieSameSite: "Lax",
        init: function (useSecureCookies, cookiePath, cookieDomain, cookieSameSite) {
            this.useSecureCookies = useSecureCookies;
            this.cookiePath = cookiePath;
            this.cookieDomain = cookieDomain;
            this.cookieSameSite = cookieSameSite;
            if (useSecureCookies && location.protocol !== "https:") {
                console.log("Error with setting useSecureCookies: You cannot use this option on http.");
            } else {
                this.cookieIsSecure = useSecureCookies;
            }
        },
        hasConsent: function () {
            var consentCookie = this.getCookie(this.CONSENT_COOKIE_NAME);
            var removedCookie = this.getCookie(this.CONSENT_REMOVED_COOKIE_NAME);
            if (!consentCookie && !removedCookie) {
                return true; // No cookies set, so opted in
            }
            if (removedCookie && consentCookie) {
                this.setCookie(this.CONSENT_COOKIE_NAME, "", -129600000);
                return false;
            }
            return consentCookie || consentCookie !== 0;
        },
        consentGiven: function () {
            this.setCookie(this.CONSENT_REMOVED_COOKIE_NAME, "", -129600000);
            this.setCookie(this.CONSENT_COOKIE_NAME, new Date().getTime(), 946080000000);
        },
        consentRevoked: function () {
            this.setCookie(this.CONSENT_COOKIE_NAME, "", -129600000);
            this.setCookie(this.CONSENT_REMOVED_COOKIE_NAME, new Date().getTime(), 946080000000);
        },
        getCookie: function (cookieName) {
            var cookiePattern = new RegExp("(^|;)[ ]*" + cookieName + "=([^;]*)"),
                cookieMatch = cookiePattern.exec(document.cookie);
            return cookieMatch ? window.decodeURIComponent(cookieMatch[2]) : 0;
        },
        setCookie: function (cookieName, value, msToExpire) {
            var expiryDate = new Date();
            expiryDate.setTime(new Date().getTime() + msToExpire);
            document.cookie =
                cookieName +
                "=" +
                window.encodeURIComponent(value) +
                (msToExpire ? ";expires=" + expiryDate.toGMTString() : "") +
                ";path=" +
                (this.cookiePath || "/") +
                (this.cookieDomain ? ";domain=" + this.cookieDomain : "") +
                (this.cookieIsSecure ? ";secure" : "") +
                ";SameSite=" +
                this.cookieSameSite;
            if ((!msToExpire || msToExpire >= 0) && this.getCookie(cookieName) !== String(value)) {
                console.log("There was an error setting cookie `" + cookieName + "`. Please check domain and path.");
            }
        },
    };

    window.showContent = showContent;
})();
